<p-tabs
  appTabsUnsavedReveal
  [value]="activeScTabIndex()"
  (valueChange)="scTabChange.emit(+$event!)"
  class="subcriteria-tabs"
  data-testid="subcriteria-tabs"
  scrollable
>
  <p-tablist>
    @for (subTab of subcriteriaTabs(); track subTab.id; let subIndex = $index) {
      <p-tab
        [value]="subIndex"
        [appTabStatus]="scTabCompletionStatus()[subIndex]"
        [appTabStatusUnsaved]="scTabsUnsaved()[subIndex]"
      >
        <span>{{ subTab.translations | translateDirectus }}</span>
      </p-tab>
    }
  </p-tablist>

  <p-tabpanels class="mt-4">
    @for (subTab of subcriteriaTabs(); track subTab.id; let subIndex = $index) {
      @switch (subTab.renderer) {
        @case (SubcriteriaRenderer.PROJECT_REFERENCES) {
          <app-tab-panel [value]="subIndex" [loading]="isProjectReferencesLoading()">
            @if (activeScTabIndex() === subIndex) {
              @if (toolId(); as current) {
                <app-project-references
                  [toolId]="current"
                  [readOnly]="projectReferencesReadOnly()"
                  [scores]="projectReferenceScores()"
                  (savedCountChange)="projectReferencesSavedCountChange.emit($event)"
                  (unsavedChange)="projectReferencesUnsavedChange.emit($event)"
                  (loadingChange)="isProjectReferencesLoading.set($event)"
                />
              } @else {
                <app-no-data label="common.item.empty" testId="no-project-references-message" />
              }
            }
          </app-tab-panel>
        }
        @default {
          <p-tabpanel [value]="subIndex">
            @if (activeScTabIndex() === subIndex) {
              <app-questionnaire-tab-content
                [attributes]="subTab.attributes"
                [badgeListItems]="badgeListItems()"
                [canSave]="canSave()"
                [isSaving]="isSaving()"
                [disabled]="disabled()"
                [showImportanceScore]="showImportanceScore()"
                [contentTestId]="'subcriteria-attributes-card'"
                [attributesListTestId]="'subcriteria-attributes-list-' + subTab.id"
                (attributeValueChange)="attributeValueChange.emit($event)"
                (commentChange)="attributeValueChange.emit($event)"
                (saveClick)="saveClick.emit()"
              />
            }
          </p-tabpanel>
        }
      }
    }
  </p-tabpanels>
</p-tabs>
